import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saved-successfully',
  templateUrl: './saved-successfully.component.html',
  styleUrls: ['./saved-successfully.component.scss']
})
export class SavedSuccessfullyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
